import { useContext } from "react";
import { ScheduleContext } from "../../context/Schedule";

export const useScheduleContext = () => {
    const context = useContext(ScheduleContext);
    if (!context) {
        throw Error("useScheduleContext without provider");
    }
    return context;
};
